import {QUESTION_TYPE} from './question.type.model';

/**
 * Questions qu'une enquête par étapes mesure étape par étape : chacune doit dire de laquelle elle
 * parle, sans quoi ses réponses ne se rattacheraient à rien dans la restitution.
 *
 * La recommandation et la satisfaction globale n'en sont pas : elles valent de tout le parcours, non
 * de l'une de ses étapes. Le commentaire non plus — il ne mesure rien.
 */
export const STAGED_QUESTION_TYPES: QUESTION_TYPE[] = [
    QUESTION_TYPE.CES,
    QUESTION_TYPE.MONO_CSAT,
    QUESTION_TYPE.MULTI_CSAT,
    QUESTION_TYPE.CHOICES,
    QUESTION_TYPE.SCALE,
];
